import type { FunctionComponent, ReactElement } from 'react';

import { L10nText } from '../../../../services/uiTranslations/reactBindings/L10nText';
import { useAutoplaySlice } from '../../../../store/slices/autoplay/selectors';
import type { TrafficLightRendererProps } from '../types';

export const LastBetsRendererConnected: FunctionComponent<TrafficLightRendererProps> = ({ timer }): ReactElement => {
  const isAutoplayInProgress = useAutoplaySlice.isInProgress();
  const remainingAutoplayCount = useAutoplaySlice.getRemainingCount();

  if (isAutoplayInProgress && remainingAutoplayCount > 0) {
    return <L10nText tk="AUTOPLAY_LEFT" dynamicValues={[remainingAutoplayCount.toString()]} />;
  }

  return (
    <>
      <L10nText tk="LASTBETS" />
      <>{timer}</>
    </>
  );
};
